import { styled } from '@mui/material/styles';

export const PageFormContainer = styled('form')({
	flex: '1 1 auto',
	display: 'flex',
	flexDirection: 'column',
});
